import {Injectable} from '@angular/core';
import {ReactiveService} from '../reactive-service.abstract';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ParamonModel} from './paramon.model';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';

@Injectable()
export class ParamonApiService extends ReactiveService implements Resolve<ParamonModel> {
    private baseUrl = environment.backEndUrlPrefix + '/' + 'db/paramon';

    constructor(private http: HttpClient) {
        super();
    }

    getNewParamon() {
        return undefined;
    }


    create(data: ParamonModel): Observable<ParamonModel> {
        return this.http.post(`${this.baseUrl}`, data);
    }

    save(paramonId: number, data: ParamonModel): Observable<ParamonModel> {
        return this.http.put(`${this.baseUrl}/${paramonId}`, data);
    }

    getParamon(paramonId: number): Observable<ParamonModel> {
        return this.http.get(`${this.baseUrl}/${paramonId}`);
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ParamonModel> | Promise<ParamonModel> | ParamonModel {
        return this.getParamon(route.params.paramonId);
    }
}
